module.exports = __webpack_public_path__ + "img/airfrair.e407dbfc.jpeg";